import { render, staticRenderFns } from "./ProfileName.vue?vue&type=template&id=b5b86c5e&scoped=true&"
import script from "./ProfileName.vue?vue&type=script&lang=js&"
export * from "./ProfileName.vue?vue&type=script&lang=js&"
import style0 from "./ProfileName.vue?vue&type=style&index=0&id=b5b86c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b86c5e",
  null
  
)

export default component.exports